<template>
  <div>
    <div>
      <Navbar />

      <section class="section">
        <div class="container">
          <div class="columns">
            <div class="column is-two-thirds"><router-view></router-view></div>
            <div class="column is-one-third">
              <div
                v-if="
                  isAuthenticated() &&
                    (!sharedState.accountAvailable ||
                      !sharedState.permissionsAvailable)
                "
                class="datamate"
              >
                <progress class="progress is-small is-primary" max="100"
                  >Fetching</progress
                >
              </div>
              <div
                v-else-if="
                  !isAuthenticated() ||
                    !sharedState.accountAvailable ||
                    !sharedState.permissionsAvailable
                "
                class="datamate"
              >
                <h1 class="title">Your Account</h1>
                <p>
                  To watch the sale and bid, sign up or login to your account.
                </p>
                <br />
                <p class="control">
                  <a class="button is-success is-large" @click="login"
                    >Sign up or login</a
                  >
                </p>
              </div>
              <div v-else class="datamate">
                <h1 class="title">Your Account</h1>
                <h1 class="subtitle">Your Buyer Codes</h1>
                <div class="field is-grouped is-grouped-multiline">
                  <div
                    class="control"
                    v-for="(permission, index) in sharedState.permissions"
                    :key="index"
                    :value="permission"
                  >
                    <div
                      v-for="(code, index) in permission.codes"
                      :key="index"
                      class="tags has-addons"
                    >
                      <span class="tag is-dark">{{ permission.site }}</span>
                      <span class="tag is-info">{{ code }}</span>
                    </div>
                  </div>
                </div>
                <h1 class="subtitle">Your Agent</h1>
                <p class="title is-spaced">{{ sharedState.account.agency }}</p>
                <!-- <h1 class="subtitle">Payments Due</h1>
                <p class="title is-spaced">$ 0</p>
                <h1 class="subtitle">Payments Overdue</h1>
                <p class="title is-spaced">$ 0</p>
                <h1 class="subtitle">Your Buyer Rating</h1>
                <p>
                  <span class="icon is-medium">
                    <i class="zmdi zmdi-star zmdi-hc-2x"></i>
                  </span>
                  <span class="icon is-medium">
                    <i class="zmdi zmdi-star-outline zmdi-hc-2x"></i>
                  </span>
                  <span class="icon is-medium">
                    <i class="zmdi zmdi-star-outline zmdi-hc-2x"></i>
                  </span>
                  <span class="icon is-medium">
                    <i class="zmdi zmdi-star-outline zmdi-hc-2x"></i>
                  </span>
                  <span class="icon is-medium">
                    <i class="zmdi zmdi-star-outline zmdi-hc-2x"></i>
                  </span>
                </p> -->
              </div>
              <br />
              <Help />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  </div>
</template>

<style lang="scss">
// Import Bulma's core
@import '~bulma/sass/utilities/_all';

// Import customizations
@import 'common/assets/bulma.scss';

// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

// User styles
@import 'common/assets/fonts.scss';
@import 'common/assets/custom.scss';

.notices .notification {
  max-width: none;
}

.notify {
  position: absolute;
  top: auto;
  right: 0;
  bottom: 25%;
  left: 0;
  z-index: 9;
  padding-right: 0.75rem;
}

.dialog .modal-card {
  max-width: none;
}

.modal-card-head,
.modal-card-foot {
  background-color: #161a25;
}

.modal-card-head {
  border-bottom: 1px solid #333;
}

.modal-card-foot {
  border-top: 1px solid #333;
}

.modal-card-body {
  background-color: #262a35;
}

.datamate {
  background-color: #262a35;
  border-color: #575a62;
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  padding: 2rem;
}

.upcoming {
  background-color: #262a35;
  border-radius: 12px;
  padding: 0rem;
}

.upcoming h1 {
  margin-top: 6rem;
}

.livenow {
  background-color: #17784d;
  font-weight: bold;
  padding: 0.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

.block {
  background-color: #262a35;
  border-radius: 12px;
  padding: 1.25rem 2.5rem 1.25rem 1.5rem;
  // overflow: hidden;
  position: relative;
}

.push-register {
  background-color: #161a25;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-1rem);
  opacity: 0;
}
</style>

<script>
import log from 'loglevel'
import { bus } from './common/bus'
import { store } from './common/store'
import { proapps } from './common/proapps'
import { ConfigProgrammatic } from 'buefy'
import JwtDecode from 'jwt-decode'
import auth0 from 'auth0-js'
import VueMobileDetection from 'vue-mobile-detection'
import Meta from 'vue-meta'

import Vue from 'vue'

Vue.use(Meta)
Vue.use(VueMobileDetection)

import VueRouter from 'vue-router'
import PageNotFound from './common/components/PageNotFound.vue'
import MarketList from './views/MarketList.vue'
import MarketDetail from './views/MarketDetail.vue'
import MarketSite from './views/MarketSite.vue'
import Agent from './views/Agent.vue'
import Search from './views/Search.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Markets',
    component: MarketList
  },
  {
    path: '/markets',
    name: 'Markets',
    component: MarketList
  },
  {
    path: '/market/:id',
    name: 'Market Detail',
    component: MarketDetail
  },
  {
    path: '/site/:id',
    name: 'Site Info',
    component: MarketSite
  },
  {
    path: '/agent/:id',
    name: 'Agent Profile',
    component: Agent
  },
  {
    path: '/search',
    name: 'Search Results',
    component: Search
  },
  {
    path: '*',
    name: 'Page not found',
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const CLIENT_ID = 'Gn2DRs0vmYaogz0u23ojOVR7FMTk6dlt'
const APP_DOMAIN = 'prostock.au.auth0.com'
const APP_TENANT = 'prostock'
const APP_ORIGIN = 'marketpro'

export default {
  router,
  metaInfo: {
    titleTemplate: '%s | Bidding mate',
    // Define meta tags here.
    meta: [
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' }
    ]
  },
  data() {
    return {
      sharedState: store,
      webAuth: null,
      notifyTimeout: null
    }
  },
  components: {
    Navbar: () => import('@/common/components/Navbar.vue'),
    Footer: () => import('@/common/components/Footer.vue'),
    Help: () => import('@/common/components/Help.vue')
  },
  mounted() {
    log.info('App mounted')

    var mountCtx = this
    var id_token = sessionStorage.getItem('id_token')
    var access_token = sessionStorage.getItem('access_token')

    // Auth0 login
    mountCtx.webAuth = new auth0.WebAuth({
      domain: APP_DOMAIN,
      clientID: CLIENT_ID,
      responseType: 'token id_token',
      scope: 'openid email',
      redirectUri: location.origin,
      audience: 'https://proapps.prostock.com.au'
    })

    // Look for a JWT
    mountCtx.webAuth.parseHash(function(err, authResult) {
      if (authResult && authResult.idToken) {
        log.info(authResult)
        // Just got the login details, extract token and setup session
        window.location.hash = ''

        id_token = authResult.idToken
        sessionStorage.setItem('id_token', authResult.idToken)
        sessionStorage.setItem(
          'expires_at',
          authResult.expiresIn * 1000 + new Date().getTime()
        )
        sessionStorage.setItem('access_token', authResult.accessToken)
        log.info('Set session details')

        window.location.replace(authResult.state)
      } else if (err) {
        // Login is invalid
        log.warn('Token is invalid')
        sessionStorage.removeItem('id_token')
        sessionStorage.removeItem('expires_at')

        mountCtx.webAuth.authorize({
          app_tenant: APP_TENANT,
          origin_app: APP_ORIGIN,
          state: window.location.href
        })
      } else if (!mountCtx.isAuthenticated()) {
        log.warn(
          'Token has expired or is not present, send user to login screen'
        )

        // webAuth.authorize({ app_tenant: APP_TENANT, origin_app: APP_ORIGIN })
      } else {
        mountCtx.sharedState.authn = true
      }
    })

    bus.$on('home', function() {
      router.push('/').catch(() => {
        /* ignore */
      })
    })
    bus.$on('logout', function() {
      // Remove tokens and expiry time from sessionStorage
      sessionStorage.removeItem('id_token')
      sessionStorage.removeItem('expires_at')

      mountCtx.webAuth.logout({
        returnTo: window.location.origin,
        clientID: CLIENT_ID,
        state: window.location.href
      })
    })
    bus.$on('auth', function() {
      mountCtx.webAuth.authorize({
        app_tenant: APP_TENANT,
        origin_app: APP_ORIGIN,
        state: window.location.href
      })
    })

    if (access_token != null && access_token.length > 0) {
      let token = JwtDecode(id_token)

      proapps
        .getUserByEmail(token.email)
        .then(user => {
          store.account = user
          store.accountAvailable = true
        })
        .catch(err => {
          log.warn('Could not get user account: ' + err)
        })

      // Get buyer codes
      proapps
        .getPermissionsByEmail(token.email)
        .then(permissions => {
          store.permissions = permissions
          store.permissionsAvailable = true
        })
        .catch(err => {
          log.error(err)
        })
    }
  },
  destroyed() {
    log.info('App destroyed')
  },

  methods: {
    isAuthenticated() {
      // Check whether the current time is past the
      // Access Token's expiry time
      var expiresAt = JSON.parse(sessionStorage.getItem('expires_at'))
      return new Date().getTime() < expiresAt
    },
    login() {
      bus.$emit('auth')
    }
  }
}

ConfigProgrammatic.setOptions({
  defaultIconPack: 'zmdi',
  customIconPacks: {
    zmdi: {
      sizes: {
        default: 'is-size-5',
        'is-small': '',
        'is-medium': 'is-size-3',
        'is-large': 'is-size-1'
      },
      iconPrefix: 'zmdi-',
      internalIcons: {
        check: 'checkmark',
        information: 'information',
        'check-circle': 'checkmark-circle-outline',
        alert: 'alert-triangle',
        'alert-circle': 'alert-circle-o',
        'arrow-up': 'arrow-up',
        'chevron-right': 'arrow-forward',
        'chevron-left': 'arrow-back',
        'chevron-down': 'arrow-down',
        eye: 'eye',
        'eye-off': 'eye-off',
        'menu-down': 'arrow-dropdown',
        'menu-up': 'arrow-dropup'
      }
    }
  }
})

let registerSW = registration => {
  // Track updates to the Service Worker.
  if (!navigator.serviceWorker.controller) {
    // The window client isn't currently controlled so it's a new service
    // worker that will activate immediately
    return
  }
  registration.update()
  if (registration.waiting) {
    // SW is waiting to activate. Can occur if multiple clients open and
    // one of the clients is refreshed.
    registration.waiting.postMessage('skipWaiting')
    return
  }
  function listenInstalledStateChange() {
    registration.installing.addEventListener('statechange', function(event) {
      if (event.target.state === 'installed') {
        // A new service worker is available, inform the user
        // if (window.confirm('New version available! OK to update?')) {
        registration.waiting.postMessage('skipWaiting')
        navigator.serviceWorker.getRegistration().then(function(reg) {
          if (reg) {
            reg.unregister().then(function() {
              window.location.reload(true)
            })
          } else {
            window.location.reload(true)
          }
        })
        // }
      }
    })
  }
  if (registration.installing) {
    return listenInstalledStateChange()
  }
  // We are currently controlled so a new SW may be found...
  // Add a listener in case a new SW is found,
  registration.addEventListener('updatefound', listenInstalledStateChange)
}

// When the user asks to refresh the UI, we'll need to reload the window
navigator.serviceWorker.addEventListener('controllerchange', function() {
  console.log('Controller loaded')
  // window.location.reload()
})
navigator.serviceWorker
  .register('/service-worker.js', { scope: '/' })
  .then(registerSW)
</script>
